"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const riemann_1 = require("./riemann");
const RiemannSumsVisualization = () => {
    const canvasRef = (0, react_1.useRef)(null);
    const [selectedFunction, setSelectedFunction] = (0, react_1.useState)('Simple Quadratic');
    const [method, setMethod] = (0, react_1.useState)('left');
    const [n, setN] = (0, react_1.useState)(10);
    const [a, setA] = (0, react_1.useState)(-2);
    const [b, setB] = (0, react_1.useState)(2);
    const [isAnimating, setIsAnimating] = (0, react_1.useState)(false);
    const [animationN, setAnimationN] = (0, react_1.useState)(1);
    const functions = (0, riemann_1.getDefaultFunctions)();
    const currentFunction = functions[selectedFunction];
    const width = 800;
    const height = 500;
    const padding = 60;
    const renderVisualization = (0, react_1.useCallback)(() => {
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        // Clear canvas
        ctx.fillStyle = '#0f172a';
        ctx.fillRect(0, 0, width, height);
        // Calculate plot area
        const plotWidth = width - 2 * padding;
        const plotHeight = height - 2 * padding;
        // Find function range for scaling
        const xRange = b - a;
        const xStep = xRange / 1000;
        let minY = Infinity;
        let maxY = -Infinity;
        for (let x = a; x <= b; x += xStep) {
            const y = evaluateFunction(x, currentFunction);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        // Add some padding to y range
        const yRange = maxY - minY;
        const yPadding = yRange * 0.1;
        minY -= yPadding;
        maxY += yPadding;
        // Coordinate transformation functions
        const xToPixel = (x) => padding + ((x - a) / xRange) * plotWidth;
        const yToPixel = (y) => padding + plotHeight - ((y - minY) / (maxY - minY)) * plotHeight;
        const pixelToX = (px) => a + ((px - padding) / plotWidth) * xRange;
        const pixelToY = (py) => minY + ((plotHeight - (py - padding)) / plotHeight) * (maxY - minY);
        // Draw axes
        ctx.strokeStyle = '#374151';
        ctx.lineWidth = 1;
        // X-axis
        const xAxisY = yToPixel(0);
        if (xAxisY >= padding && xAxisY <= height - padding) {
            ctx.beginPath();
            ctx.moveTo(padding, xAxisY);
            ctx.lineTo(width - padding, xAxisY);
            ctx.stroke();
        }
        // Y-axis
        const yAxisX = xToPixel(0);
        if (yAxisX >= padding && yAxisX <= width - padding) {
            ctx.beginPath();
            ctx.moveTo(yAxisX, padding);
            ctx.lineTo(yAxisX, height - padding);
            ctx.stroke();
        }
        // Draw grid lines
        ctx.strokeStyle = '#1f2937';
        ctx.lineWidth = 0.5;
        // Vertical grid lines
        for (let i = 1; i <= 10; i++) {
            const x = a + (i / 10) * xRange;
            const px = xToPixel(x);
            ctx.beginPath();
            ctx.moveTo(px, padding);
            ctx.lineTo(px, height - padding);
            ctx.stroke();
        }
        // Horizontal grid lines
        for (let i = 1; i <= 8; i++) {
            const y = minY + (i / 8) * (maxY - minY);
            const py = yToPixel(y);
            ctx.beginPath();
            ctx.moveTo(padding, py);
            ctx.lineTo(width - padding, py);
            ctx.stroke();
        }
        // Draw function curve
        ctx.strokeStyle = '#6366f1';
        ctx.lineWidth = 3;
        ctx.beginPath();
        let firstPoint = true;
        for (let x = a; x <= b; x += xStep) {
            const y = evaluateFunction(x, currentFunction);
            const px = xToPixel(x);
            const py = yToPixel(y);
            if (firstPoint) {
                ctx.moveTo(px, py);
                firstPoint = false;
            }
            else {
                ctx.lineTo(px, py);
            }
        }
        ctx.stroke();
        // Calculate and draw Riemann sum
        const currentN = isAnimating ? animationN : n;
        const riemannResult = (0, riemann_1.calculateRiemannSum)(currentFunction, a, b, currentN, method);
        // Draw rectangles
        ctx.fillStyle = method === 'trapezoidal' ? 'rgba(99, 102, 241, 0.3)' : 'rgba(99, 102, 241, 0.4)';
        ctx.strokeStyle = '#6366f1';
        ctx.lineWidth = 1;
        riemannResult.rectangles.forEach(rect => {
            const rectLeft = xToPixel(rect.x - rect.width / 2);
            const rectRight = xToPixel(rect.x + rect.width / 2);
            const rectTop = yToPixel(rect.height);
            const rectBottom = yToPixel(0);
            if (method === 'trapezoidal') {
                // Draw trapezoid
                const leftX = xToPixel(rect.x - rect.width / 2);
                const rightX = xToPixel(rect.x + rect.width / 2);
                const leftY = yToPixel(evaluateFunction(rect.x - rect.width / 2, currentFunction));
                const rightY = yToPixel(evaluateFunction(rect.x + rect.width / 2, currentFunction));
                ctx.beginPath();
                ctx.moveTo(leftX, yToPixel(0));
                ctx.lineTo(leftX, leftY);
                ctx.lineTo(rightX, rightY);
                ctx.lineTo(rightX, yToPixel(0));
                ctx.closePath();
                ctx.fill();
                ctx.stroke();
            }
            else {
                // Draw rectangle
                ctx.fillRect(rectLeft, rectTop, rectRight - rectLeft, rectBottom - rectTop);
                ctx.strokeRect(rectLeft, rectTop, rectRight - rectLeft, rectBottom - rectTop);
            }
        });
        // Draw axis labels
        ctx.fillStyle = '#9ca3af';
        ctx.font = '12px ui-sans-serif, system-ui';
        ctx.textAlign = 'center';
        // X-axis labels
        for (let i = 0; i <= 10; i++) {
            const x = a + (i / 10) * xRange;
            const px = xToPixel(x);
            ctx.fillText(x.toFixed(1), px, height - padding + 20);
        }
        // Y-axis labels
        ctx.textAlign = 'right';
        for (let i = 0; i <= 8; i++) {
            const y = minY + (i / 8) * (maxY - minY);
            const py = yToPixel(y);
            ctx.fillText(y.toFixed(1), padding - 10, py + 4);
        }
        // Draw function label
        ctx.fillStyle = '#6366f1';
        ctx.font = 'bold 14px ui-sans-serif, system-ui';
        ctx.textAlign = 'left';
        ctx.fillText((0, riemann_1.getFunctionString)(currentFunction), padding, padding - 10);
    }, [currentFunction, method, n, a, b, isAnimating, animationN]);
    const evaluateFunction = (x, func) => {
        switch (func.type) {
            case 'quadratic':
                return func.a * x * x + func.b * x + func.c;
            case 'cubic':
                return func.a * x * x * x + func.b * x * x + func.c * x;
            case 'exponential':
                return func.a * Math.exp(func.b * x) + func.c;
            case 'logarithmic':
                return func.a * Math.log(Math.abs(x) + 0.1) + func.c;
            case 'trigonometric':
                return func.amplitude * Math.sin(func.frequency * x) + func.c;
            case 'polynomial':
                return func.a * x * x * x * x + func.b * x * x * x + func.c * x * x + x;
            default:
                return 0;
        }
    };
    (0, react_1.useEffect)(() => {
        renderVisualization();
    }, [renderVisualization]);
    const startAnimation = () => {
        setIsAnimating(true);
        setAnimationN(1);
        const animate = () => {
            setAnimationN(prev => {
                if (prev >= 50) {
                    setIsAnimating(false);
                    return n;
                }
                return prev + 1;
            });
        };
        const interval = setInterval(animate, 100);
        setTimeout(() => clearInterval(interval), 5000);
    };
    const riemannResult = (0, riemann_1.calculateRiemannSum)(currentFunction, a, b, isAnimating ? animationN : n, method);
    const exactIntegral = (0, riemann_1.calculateExactIntegral)(currentFunction, a, b);
    const error = Math.abs(riemannResult.sum - exactIntegral);
    return (react_1.default.createElement("div", { className: "riemann-visualization" },
        react_1.default.createElement("div", { className: "visualization-header" },
            react_1.default.createElement("h1", null, "Riemann Sums for Integrals"),
            react_1.default.createElement("p", null, "Visualize the area under a curve using different approximation methods. Watch how increasing the number of rectangles brings us closer to the exact integral.")),
        react_1.default.createElement("div", { className: "controls" },
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", { htmlFor: "function" }, "Function:"),
                react_1.default.createElement("select", { id: "function", value: selectedFunction, onChange: (e) => setSelectedFunction(e.target.value) }, Object.keys(functions).map(name => (react_1.default.createElement("option", { key: name, value: name }, name))))),
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", { htmlFor: "method" }, "Method:"),
                react_1.default.createElement("select", { id: "method", value: method, onChange: (e) => setMethod(e.target.value) },
                    react_1.default.createElement("option", { value: "left" }, "Left Endpoint"),
                    react_1.default.createElement("option", { value: "right" }, "Right Endpoint"),
                    react_1.default.createElement("option", { value: "midpoint" }, "Midpoint"),
                    react_1.default.createElement("option", { value: "trapezoidal" }, "Trapezoidal"))),
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", { htmlFor: "n" }, "Number of intervals:"),
                react_1.default.createElement("input", { id: "n", type: "range", min: "1", max: "100", value: isAnimating ? animationN : n, onChange: (e) => setN(parseInt(e.target.value)), disabled: isAnimating }),
                react_1.default.createElement("span", null, isAnimating ? animationN : n)),
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", { htmlFor: "a" }, "Lower bound (a):"),
                react_1.default.createElement("input", { id: "a", type: "number", step: "0.1", value: a, onChange: (e) => setA(parseFloat(e.target.value)), disabled: isAnimating })),
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", { htmlFor: "b" }, "Upper bound (b):"),
                react_1.default.createElement("input", { id: "b", type: "number", step: "0.1", value: b, onChange: (e) => setB(parseFloat(e.target.value)), disabled: isAnimating })),
            react_1.default.createElement("button", { onClick: startAnimation, className: "animate-button", disabled: isAnimating }, isAnimating ? 'Animating...' : 'Animate Refinement')),
        react_1.default.createElement("div", { className: "canvas-container" },
            react_1.default.createElement("canvas", { ref: canvasRef, width: width, height: height, style: {
                    border: '1px solid #333',
                    borderRadius: '8px',
                    background: '#0f172a'
                } })),
        react_1.default.createElement("div", { className: "results-panel" },
            react_1.default.createElement("div", { className: "result-item" },
                react_1.default.createElement("strong", null,
                    "Riemann Sum (",
                    method,
                    "):"),
                " ",
                riemannResult.sum.toFixed(6)),
            react_1.default.createElement("div", { className: "result-item" },
                react_1.default.createElement("strong", null, "Exact Integral:"),
                " ",
                exactIntegral.toFixed(6)),
            react_1.default.createElement("div", { className: "result-item" },
                react_1.default.createElement("strong", null, "Error:"),
                " ",
                error.toFixed(6)),
            react_1.default.createElement("div", { className: "result-item" },
                react_1.default.createElement("strong", null, "Relative Error:"),
                " ",
                ((error / Math.abs(exactIntegral)) * 100).toFixed(2),
                "%")),
        react_1.default.createElement("div", { className: "info-panel" },
            react_1.default.createElement("h3", null, "About Riemann Sums"),
            react_1.default.createElement("p", null, "Riemann sums approximate the area under a curve by dividing the interval into subintervals and summing the areas of rectangles (or trapezoids). As the number of subintervals increases, the approximation approaches the exact value of the definite integral."),
            react_1.default.createElement("p", null,
                react_1.default.createElement("strong", null, "Methods:")),
            react_1.default.createElement("ul", null,
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Left/Right Endpoint:"),
                    " Uses the function value at the left or right edge of each subinterval"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Midpoint:"),
                    " Uses the function value at the center of each subinterval (often most accurate)"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Trapezoidal:"),
                    " Uses the average of function values at both edges (approximates with trapezoids)")))));
};
exports.default = RiemannSumsVisualization;
